import type { EmailStarterTemplate } from '../types'

import { abandonedCheckoutStarter } from './abandoned-checkout'
import { blankStarter } from './blank'
import { orderPaidStarter } from './order-paid'
import { orderRefundedStarter } from './order-refunded'
import { promoCodeStarter } from './promo-code'
import { subscriptionRebillUpcomingStarter } from './subscription-rebill-upcoming'

export {
    abandonedCheckoutStarter,
    blankStarter,
    orderPaidStarter,
    orderRefundedStarter,
    promoCodeStarter,
    subscriptionRebillUpcomingStarter,
}

/**
 * Default starter gallery — ordered by most common first. Used when no
 * concrete email type has been chosen yet (so merchants can still discover
 * layouts without committing to a trigger first).
 */
export const DEFAULT_STARTERS: EmailStarterTemplate[] = [
    orderPaidStarter,
    abandonedCheckoutStarter,
    orderRefundedStarter,
    subscriptionRebillUpcomingStarter,
    promoCodeStarter,
    blankStarter,
]

/**
 * Map from tagada's `EmailTemplateType` (see `src/lib/schema.ts`) to the
 * starters most relevant to that trigger. Every enum value is covered so
 * we never leak an irrelevant layout (e.g. a promo-code starter for a
 * refund email). Types without a dedicated starter fall back to `blank`
 * — the merchant can still start from a clean slate without being misled.
 */
export const STARTERS_BY_EMAIL_TYPE: Record<string, EmailStarterTemplate[]> = {
    order_paid: [orderPaidStarter, blankStarter],
    order_pending: [orderPaidStarter, blankStarter],
    order_refunded: [orderRefundedStarter, blankStarter],
    abandoned_checkout: [abandonedCheckoutStarter, blankStarter],
    customer_promotion_code: [promoCodeStarter, blankStarter],
    subscription_rebill_upcoming: [subscriptionRebillUpcomingStarter, blankStarter],
    subscription_rebill_succeeded: [orderPaidStarter, blankStarter],
    subscription_canceled: [blankStarter],
    subscription_past_due: [subscriptionRebillUpcomingStarter, blankStarter],
    club_membership_started: [blankStarter],
    club_membership_deactivated: [blankStarter],
    free_trial_expiration_incoming: [subscriptionRebillUpcomingStarter, blankStarter],
}
